import { getPrinterConfig } from './utils/qzHelper';
const qz = require("qz-tray");

export async function print(documents) {
  const { printer } = await getPrinterConfig() || {};
  if(!documents[0] || !printer) return false ;

  try {
    const config = await qz.configs.create(printer);
    return await qz.print(config, [documents[0].data]);
  }
  catch(e) {
    console.log('print error:', e)
  }
  // return request.post('https://printy.noondv.team:9501/print', { documents }, { headers: { Accept: '*' } });
}

export function generateLabel(data) {

  // https://stackoverflow.com/a/6259543
  const labelParts = (data.label || '').match(/.{1,20}/g) || [];
  const qty = data.qty || 1;
  const { offsetX = 0, offsetY = 0 } =  getPrinterConfig() || {};
  const topRightTxt = data.size || data.variant_en || '';
  const brandTruncated = `${(data.brand_code || '').slice(0,7).replace(/_/g, ' ').toUpperCase()} ${((data.brand_code || '').length > 7) ? '...' : ''}`;
  const topRightTxtTruncated = `${topRightTxt.slice(0,5).toUpperCase()}`;
  const rightAlignOffset = (5 - topRightTxtTruncated.length) * 10;
  const zplLabel = `
      ^XA
      ^FX section with bar code.
      ^FO${Number(offsetX) + 30},${Number(offsetY) + 30}^BY2^BCN,60,,,,A^FD${data.barcode}^FS
      ^FX section with details.
      ^CF0,18
      ^FO${Number(offsetX) + 30},${Number(offsetY) + 115}^FD${brandTruncated}^FS
      ^FO${Number(offsetX) + 30},${Number(offsetY) + 135}^FD${labelParts[0] || ''}^FS
      ^FO${Number(offsetX) + 30},${Number(offsetY) + 155}^FD${labelParts[1] || ''}^FS
      ^FO${Number(offsetX) + 30},${Number(offsetY) + 175}^FD${labelParts[2] || ''}^FS
      ^CF0,18
      ^FO${Number(offsetX) + 200 + rightAlignOffset},${Number(offsetY) + 115}^FD${topRightTxtTruncated}${(topRightTxt.length > 5) ? '...' : ''}^FS
      ^PQ${qty}
      ^JZN
      ^XZ
    `;

  return { type: 'zpl', data: zplLabel, ref: 'zplLabel' };
}

export const EMPTY_LABEL = generateLabel({
  barcode: '', variant_en: '', brand_code: '', partner_bm: '', label: '-- ✂ - CUT HERE - ✂ --'
});

export function generatePutaway(data) {
  console.info('Generating Putaway label for printing with', data);

  let lbl = `
I8,A,001


Q203,024
q831
rN
S5
D10
ZT
JF
O
R263,0
f100
N
B269,188,2,1,2,6,54,B,"W00000R"
A269,52,2,4,1,1,N,"99999"
A270,96,2,4,1,1,N,"W00000I"
P1
`;

  let { receipt_nr, invoice_nr, units } = data;
  let label = lbl;
  label = label.replace('W00000R', receipt_nr);
  label = label.replace('W00000I', invoice_nr);
  label = label.replace('99999', units);
  return { data: label, type: 'epl' };
}
export function generateMpLabel(data) {
  return generateLabel(data);
// let lbl =`
// N
// q304
// Q160
// B292,180,2,1,2,6,54,B,"BARCODE"
// A292,95,2,1,0,0,N,"IDPARTNER"
// A292,80,2,2,0,0,N,"PBARCODE"
// A95,70,2,2,0,0,N,""
// A292,60,2,1,0,0,N,""
// A292,45,2,1,0,0,N,""
// A292,25,2,1,0,0,N,""
// P1
// `;
//   const qty = data.qty || 1;
//   let label = lbl.replace('P1', `P${qty}`)
//                 .replace('BARCODE', data.barcode)
//                 .replace('IDPARTNER', data.id_partner)
//                 .replace('PBARCODE', data.pbarcode || '')     
//   return { type: 'epl', data: label, ref: 'eplLabel' };
}



// WEBPACK FOOTER //
// ./src/print.js